export default __webpack_public_path__ + "assets/front/scss/common.26b55b28c0a1ff3d24920d7d1779b6cf.css";